"use client";
import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { getBackgroundColor } from "../../../../utils/color.js";
import { ColorBlack, SpaceSm, SpaceMd, SpaceLg } from "@nxt-costco-com/forge-design-tokens";
import { ImageVideo } from "../../ImageVideo/index.js";
import { MarketingTypography } from "../../MarketingTypography/index.js";
import { FillImage } from "../styles.js";
import { CostcoBox } from "../../../Util/CostcoBox.js";
import { StyledItemBannerHeader, StyledItemBannerCircleImage, StyledItemBannerFooter } from "./styles.js";
const StaticTileBlock = ({
  locale,
  entryId,
  hasBottomStrip,
  programCardConfig,
  roundedFirstTile,
  roundedLastTile,
  tile,
  tileCounter
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  const {
    tile_header: { header_text, header_badge, header_badge_alt_text },
    tile_body: { background_color, image_alt_text, image },
    tile_footer: { tile_text }
  } = tile;
  const backgroundImageFirstObjUrl = Array.isArray(image) && image[0] ? image[0].url : void 0;
  const hasHeaderBadge = !!header_badge[0];
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(
      StyledItemBannerHeader,
      {
        color: ((_b = (_a = header_text == null ? void 0 : header_text.color) == null ? void 0 : _a.text_color) == null ? void 0 : _b.hex) ? (_d = (_c = header_text == null ? void 0 : header_text.color) == null ? void 0 : _c.text_color) == null ? void 0 : _d.hex : ColorBlack,
        backgroundColor: getBackgroundColor(header_text.color),
        headerAlignment: programCardConfig == null ? void 0 : programCardConfig.tile_header_alignment,
        roundedFirstTile,
        roundedLastTile,
        sx: {
          minHeight: { lg: "90px" }
          // On desktop in shop menu need to make sure it the circle isn't bigger than the header
        },
        children: [
          hasHeaderBadge && /* @__PURE__ */ jsx(
            StyledItemBannerCircleImage,
            {
              sx: {
                height: { lg: "80px", md: "70px", xs: "58px" },
                width: { lg: "80px", md: "70px", xs: "58px" }
              },
              children: /* @__PURE__ */ jsx(
                FillImage,
                {
                  src: (_e = header_badge == null ? void 0 : header_badge[0]) == null ? void 0 : _e.url,
                  alt: header_badge_alt_text,
                  loading: "lazy"
                }
              )
            }
          ),
          /* @__PURE__ */ jsx(
            CostcoBox,
            {
              sx: {
                marginLeft: hasHeaderBadge && (programCardConfig == null ? void 0 : programCardConfig.tile_header_alignment) === "left" ? { lg: "92px", md: "82px", xs: "70px" } : SpaceSm
              },
              children: /* @__PURE__ */ jsx(
                MarketingTypography,
                {
                  sx: {
                    color: (_g = (_f = header_text == null ? void 0 : header_text.color) == null ? void 0 : _f.text_color) == null ? void 0 : _g.hex
                  },
                  component: header_text == null ? void 0 : header_text.select_semantics_type,
                  isMarkdown: true,
                  uniqueId: `programcardtile_header_${entryId}_${tileCounter}`,
                  variant: header_text == null ? void 0 : header_text.select_text_type,
                  children: header_text == null ? void 0 : header_text.markdown_text
                }
              )
            }
          )
        ]
      }
    ),
    backgroundImageFirstObjUrl && /* @__PURE__ */ jsx(
      CostcoBox,
      {
        sx: {
          background: getBackgroundColor(background_color),
          borderBottomLeftRadius: hasBottomStrip && tileCounter === 0 ? "10px" : "0px"
        },
        children: /* @__PURE__ */ jsx(
          ImageVideo,
          {
            enableMobileImageVariation: false,
            image,
            imageAltText: image_alt_text,
            imageSx: { paddingTop: { lg: SpaceMd, xs: SpaceSm } },
            locale,
            imageUrl: backgroundImageFirstObjUrl
          }
        )
      }
    ),
    (tile_text == null ? void 0 : tile_text.markdown_text) && /* @__PURE__ */ jsx(
      StyledItemBannerFooter,
      {
        sx: {
          paddingTop: (Array.isArray(image) && !((_h = image[0]) == null ? void 0 : _h.url) || !Array.isArray(image)) && {
            lg: SpaceLg,
            xs: SpaceSm
          }
        },
        backgroundColor: getBackgroundColor(tile_text == null ? void 0 : tile_text.color),
        footerAlignment: programCardConfig == null ? void 0 : programCardConfig.tile_footer_alignment,
        children: /* @__PURE__ */ jsx(
          MarketingTypography,
          {
            sx: {
              color: (_j = (_i = tile_text == null ? void 0 : tile_text.color) == null ? void 0 : _i.text_color) == null ? void 0 : _j.hex,
              textAlign: programCardConfig == null ? void 0 : programCardConfig.tile_footer_alignment
            },
            component: tile_text == null ? void 0 : tile_text.select_semantics_type,
            isMarkdown: true,
            uniqueId: `programcardtile_footer_${entryId}_${tileCounter}`,
            variant: tile_text == null ? void 0 : tile_text.select_text_type,
            children: tile_text == null ? void 0 : tile_text.markdown_text
          }
        )
      }
    )
  ] });
};
export {
  StaticTileBlock
};
